// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__rDpdT","inputWrap":"CustomTip_inputWrap__382TD"};